var _jsxFileName = "/repo/packages/webassets/src/components/Header/wrench/components/experiments/grow3505/useGrow3505.tsx",
  _this = this;
import React from 'react';
import { useExperiment } from '../../../../../Experiments';
import Treatment from '../../../../../Experiments/Treatment';
export var GROW_3505_EXPERIMENT = 'grow_3505_waffle_workgroups';
export var GROW_3505_CONTROL = "".concat(GROW_3505_EXPERIMENT, "_control");
export var GROW_3505_TREATMENT = "".concat(GROW_3505_EXPERIMENT, "_treatment");
export var useGrow3505Experiment = function useGrow3505Experiment() {
  var _useExperiment = useExperiment({
      name: GROW_3505_EXPERIMENT,
      treatmentNames: [GROW_3505_CONTROL, GROW_3505_TREATMENT]
    }),
    treatments = _useExperiment.treatments,
    loading = _useExperiment.loading;
  var assignmentControls = function assignmentControls(treatmentComponent, controlComponent) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Treatment, {
      when: GROW_3505_TREATMENT,
      treatments: treatments,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 29,
        columnNumber: 9
      }
    }, treatmentComponent), /*#__PURE__*/React.createElement(Treatment, {
      when: GROW_3505_CONTROL,
      control: true,
      treatments: treatments,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 32,
        columnNumber: 9
      }
    }, controlComponent));
  };
  return {
    loading: loading,
    assignmentControls: assignmentControls
  };
};
//# sourceMappingURL=useGrow3505.js.map